import React from 'react';
import { ViewportProvider } from '@vlinder-web/viewport-provider-react';
import { AppNavigator } from '../AppNavigator';

import { ThemeProvider } from '../providers/theme';
import { Accessories } from './Accessories';
import Watermark from '@uiw/react-watermark';

export const BootstrapApp = () => {
  return (
    <>
      <ThemeProvider>
        <ViewportProvider>
          <Watermark
            content='INFOSYS'
            rotate={-20}
            gapY={0}
            gapX={5}
            width={100}
            gapY={80}
            height={5}
            fontSize={12}
            fontColor='rgb(255 0 0 / 25%)'
          >
            <AppNavigator />
          </Watermark>
        </ViewportProvider>
      </ThemeProvider>
      <Accessories />
    </>
  );
};
